import { DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES } from "@/components/CurrencySelector/constants";

export const getCurrencySymbol = (currency: string): string => {
  const currencyData = DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES.find(
    (c) => c.code === currency,
  );
  return currencyData?.symbol || "$";
};
